import { ResponsiveScreenSizesInt } from "app/utils/const";
import { SessionHelper } from "./sessionHelper";

export const ROUTES = {
  root: "/",
  login: ["/reset/:token", "/login"],
  register: "/register",
  asianEvents: "/asian/events/",
  asianEventsDetail: "/asian/events/:id",
  asianEventsPopular: "/asian/events/popular/",
  asianOpenBets: "/asian/openbets/",
  asianStatement: "/asian/statement/",
  asianSettings: "/asian/settings/",
  asianFunding: "/asian/funding/",
  asianFundingAquapay: "/asian/funding/aquapay",
  asianFundingSkrill: "/asian/funding/skrill",
  asianFundingNuveiCreditCard: "/asian/funding/nuvei",
  asianFundingNuveiInterac: "/asian/funding/interac",
  asianFundingApplePay: "/asian/funding/apple_pay",
  asianFundingNuveiGooglePay: "/asian/funding/google_pay",
  asianFundingNetellerSuccess: "/asian/funding/neteller/success/",
  asianFundingNetellerError: "/asian/funding/neteller/error/",
  asianFundingNetellerWithdrawSuccess:
    "/asian/funding/neteller/withdrawSuccess/",
  asianFundingNeteller: "/asian/funding/neteller",
  asianFundingBankwire: "/asian/funding/bankwire",
  asianAccountVerification: "/asian/accountVerification/",
  asianHelpAndLearning: "/asian/settings/helpandlearning/",
  asianHelpAndLearningWelcomeHelpAndLearning:
    "/asian/settings/helpandlearning/welcome/helpandlearning/",
  asianHelpAndLearningGettingStartedFundingYourAccount:
    "/asian/settings/helpandlearning/gettingstarted/fundingyouraccount/",
  asianHelpAndLearningGettingStartedPlacingABet:
    "/asian/settings/helpandlearning/gettingstarted/placingabet/",
  asianHelpAndLearningGettingStartedOurOdds:
    "/asian/settings/helpandlearning/gettingstarted/ourodds/",
  asianHelpAndLearningGettingStartedQuickLinks:
    "/asian/settings/helpandlearning/gettingstarted/quicklinks/",
  asianHelpAndLearningRulesAndRegulationsSportsRules:
    "/asian/settings/helpandlearning/rulesandregulations/sportsrules/",
  asianHelpAndLearningRulesAndRegulationsMarketRules:
    "/asian/settings/helpandlearning/rulesandregulations/marketrules/",
  asianHelpAndLearningRulesAndRegulationsCodeOfConduct:
    "/asian/settings/helpandlearning/rulesandregulations/codeofconduct/",
  asianHelpAndLearningContactAndSupportContactUs:
    "/asian/settings/helpandlearning/contactandsupport/contactus/",
  asianHelpAndLearningFaqsMyAccount:
    "/asian/settings/helpandlearning/faqs/myaccount/",
  asianHelpAndLearningFaqsFunding:
    "/asian/settings/helpandlearning/faqs/funding/",
  asianHelpAndLearningFaqsBetting:
    "/asian/settings/helpandlearning/faqs/betting/",
  asianHelpAndLearningAboutUsLicenceInformation:
    "/asian/settings/helpandlearning/aboutus/licenceInformation/",
  asianHelpAndLearningResponsibleGaming:
    "/asian/settings/helpandlearning/responsiblegaming/",
  asianHelpAndLearningSelfExclusion:
    "/asian/settings/helpandlearning/selfexclusion/",
  asianHelpAndLearningTermsAndConditions:
    "/asian/settings/helpandlearning/termsandconditions/termsandconditions/",
  asianHelpAndLearningTermsAndConditionsPrivacyPolicy:
    "/asian/settings/helpandlearning/termsandconditions/privacypolicy/",
  asianManageFunding: "/asian/settings/managefunding/",
  asianProfile: "/asian/settings/profile/",
  asianSingleEvent: "/asian/events/singleevent/:id",
  asianBets: "/asian/singleevent/bets/",
  events: "/events/",
  eventsBySport: "/sport/:id",
  eventsByCompetition: "/competition/:id/",
  bookmarks: "/bookmarks/",
  futures: "/futures/",
  event: "/event/:id",
  eventDetail: "/events/:id",
  singleEventDetail: "/event/:id",
  bets: "/singleevent/bets/",
  favourites: "/favourites/",
  helpAndLearning: "/account/helpandlearning/",
  AsianHelpAndLearning: "/asian/account/helpandlearning/",
  helpAndLearningWelcomeHelpAndLearning:
    "/account/helpandlearning/welcome/helpandlearning",
  helpAndLearningGettingStartedFundingYourAccount:
    "/account/helpandlearning/gettingstarted/fundingyouraccount",
  helpAndLearningGettingStartedPlacingABet:
    "/account/helpandlearning/gettingstarted/placingabet",
  helpAndLearningGettingStartedOurOdds:
    "/account/helpandlearning/gettingstarted/ourodds",
  helpAndLearningGettingStartedQuickLinks:
    "/account/helpandlearning/gettingstarted/quicklinks",
  helpAndLearningRulesAndRegulationsSportsRules:
    "/account/helpandlearning/rulesandregulations/sportsrules",
  helpAndLearningRulesAndRegulationsMarketRules:
    "/account/helpandlearning/rulesandregulations/marketrules",
  helpAndLearningRulesAndRegulationsCodeOfConduct:
    "/account/helpandlearning/rulesandregulations/codeofconduct",
  helpAndLearningContactAndSupportContactUs:
    "/account/helpandlearning/contactandsupport/contactus",
  helpAndLearningFaqsMyAccount: "/account/helpandlearning/faqs/myaccount",
  helpAndLearningFaqsFunding: "/account/helpandlearning/faqs/funding",
  helpAndLearningFaqsBetting: "/account/helpandlearning/faqs/betting",
  helpAndLearningAboutUsLicenceInformation:
    "/account/helpandlearning/aboutus/licenceinformation",
  helpAndLearningResponsibleGaming:
    "/account/helpandlearning/responsiblegaming",
  helpAndLearningSelfExclusion: "/account/helpandlearning/selfexclusion",
  helpAndLearningTermsAndConditions:
    "/account/helpandlearning/termsandconditions/termsandconditions",
  helpAndLearningTermsAndConditionsPrivacyPolicy:
    "/account/helpandlearning/termsandconditions/privacypolicy",
  reports: "/reports/",
  statementReports: "/reports/statement",
  manageFunding: "/manageFunding/",
  profile: "/profile/",
  promoCategory: "/link/:category/:id",
  account: "/account/",
  asianAccount: "/asian/account/",
  accountVerification: "/accountVerification/",
  accountcontrols: "/account/controls/:id?",
  losslimits: "/account/controls/losslimits",
  selfexclusion: "/account/controls/selfexclusion",
};

export const getRoutePathForView = () => {
  // Need to specifiy different Routes for asian and
  // euro views, to allow using ManageFunding components in the asian view.
  // Euro desktop and mobile views use the same route.
  // Need a check for mobile here also for the case when user moves
  // from asian desktop to mobile after changing the size of the viewport
  //  - with the current setup the view remains set as asian when in mobile,
  // if resizing window from euro view to mobile, view remains set as euro.
  const isMobile =
    window.innerWidth <= ResponsiveScreenSizesInt.mobile || false;
  const path =
    SessionHelper.isAsianSessionView() && !isMobile
      ? "/asian/funding/"
      : "/manageFunding/";
  return path;
};
